import React from 'react';
import { AccordionPanel } from '../../../../../CommonComponents/OPL/Accordion/AccordionPanel/AccordionPanel';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { WhatIfTypeDTO } from '../../api/useWhatIfGroupsQuery';
import { StyledAccordionButton, StyledItem } from '../../WhatIfs.styles';

interface WhatIfGroupProps {
  id: string;

  label: string;
  isExpanded: boolean;
  onExpanded: (id: string) => void;
  onWhatIfTypeChange: (whatIfType: WhatIfTypeDTO) => void;
  whatIfTypes: WhatIfTypeDTO[];
}

export const WhatIfGroup = ({
  id,
  label,
  whatIfTypes,
  isExpanded,
  onExpanded,
  onWhatIfTypeChange,
}: WhatIfGroupProps) => (
  <>
    <StyledAccordionButton
      id={`${id}-button`}
      panelId={`${id}-panel`}
      isActive={isExpanded}
      onClick={() => onExpanded(id)}
    >
      {label}
    </StyledAccordionButton>

    <AccordionPanel
      id={`${id}-panel`}
      buttonId={`${id}-button`}
      isActive={isExpanded}
      css="border-radius: 0;"
    >
      {whatIfTypes.map(type => (
        <StyledItem
          key={type.WhatIf.WhatIfType}
          onClick={() => onWhatIfTypeChange(type)}
          aria-pressed={type.IsApplied}
        >
          {type.IsApplied ? (
            <Icon fontSize="body" className="fas fa-check" />
          ) : (
            <Box width={16} height={16} />
          )}

          <Text fontWeight={500} color="inherit">
            {type.IsApplied ? type.Title : type.DefaultTitle}
          </Text>
        </StyledItem>
      ))}
    </AccordionPanel>
  </>
);
